<template>
  <div v-if="showDialog" class="help" ref="help">
   <div class="title">
    <span>{{title}}</span>
    <i class="el-icon-close close" @click="close"></i>
  </div>
   <div class="content">
    <div>
      <iframe ref="iframe" id="iframe" v-show="title === '操作手册'" :src="iframeSrc" frameborder="0" width="100%" :height="isPro ? 550 : 710 " :style="{ 'margin-top': isPro ? 0 : '-120px'}"></iframe>
      <iframe ref="iframe" id="iframe1" v-show="title === '常见问题'" :src="iframeSrc1" frameborder="0" width="100%" :height="isPro ? 550 : 710 " :style="{ 'margin-top': isPro ? 0 : '-120px'}"></iframe>
    </div>
    <div v-show="title === '智库问答'">
      <Reply></Reply>
    </div>
  </div>
  </div>
 </template>

<script>
import Reply from './Reply'
export default {
  name: 'Help',
  components: {
    Reply
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isBlack () {
      return this.$store.state.theme === 'black'
    },
    iframeSrc () {
      return process.env.VUE_APP_FRAME
    },
    iframeSrc1 () {
      return process.env.VUE_APP_FRAME1
    },
    isPro () {
      return process.env.VUE_APP_FRAME_EV === 'production'
    }
  },
  watch: {
    // title () {
    //   if (this.title === '操作手册') {
    //     const frame = document.getElementById('iframe')
    //     frame.onload = () => {
    //       const frameDocument = frame.contentDocument || frame.contentWindow.document
    //       frameDocument.getElementsByTagName('img').style.filter = 'invert(1)'
    //     }
    //   }
    // }
  },
  created () {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    close () {
      this.$emit('closeDialog')
    }
  }
}
</script>

 <style scoped lang='scss'>
 .help{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  margin: auto;
  width: 1170px;
  height: 700px;
  background: var(--map-popup-bg);
  color: var(--header-bar-title-color);
  box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
  border-radius: 10px;
  .title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 19px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    border-bottom: 1px solid var(--right-bg-tab);
    .close{
      cursor: pointer;
    }
  }
  .content{
    overflow: hidden;
    padding: 28px;
    margin-top: 20px;
  }
 }
 </style>
